<template>
  <v-container class="mt-16" fluid>
    <v-row class="noimprimir">
      <v-col cols="4"></v-col>
      <v-col>
        <v-text-field
          @input="obtenerEnviosMostrador"
          v-model="referenciaEnvio"
          autocomplete="new"
          clearable
          label="Envio a consultar"
          outlined
        ></v-text-field>
      </v-col>
      <v-col cols="4"></v-col>
    </v-row>
    <v-row class="noimprimir">
      <v-col cols="3"></v-col>
      <v-col cols="6" v-if="historialEnviosMostrador.length == 1">
        <div>
          <div style="text-align:center;width:100%;">
            <span
              style="font-weight:bold;color:red;font-size:40px;"
              v-if="historialEnviosMostrador[0].ESTADO == 'Cancelado'"
            >
              ENVÍO CANCELADO
            </span>
          </div>
          <v-btn
            v-if="historialEnviosMostrador[0].ESTADO != 'Cancelado'"
            style="height:50px;font-size:20px;"
            @click="
              mostrarModalCambioDireccion = true;
              idEnvioObtenida = historialEnviosMostrador[0].REFERENCIA;
              direccionObtenida = historialEnviosMostrador[0].DIRECCION;
            "
            color="green"
            class="mr-2 mb-2"
            block
            dark
            >CAMBIO DIRECCIÓN
            <v-icon small class="mr-2">
              mdi-home
            </v-icon></v-btn
          >
          <v-btn
            v-if="
              historialEnviosMostrador[0].ESTADO != 'Cancelado' &&
                mostrarBotonEditarGuias(historialEnviosMostrador[0])
            "
            style="height:50px;font-size:20px;"
            @click="editarEnvio(historialEnviosMostrador[0].REFERENCIA)"
            class="mb-2"
            dark
            block
            color="black"
          >
            EDITAR GUÍAS
            <v-icon small class="mr-2">
              mdi-tooltip-edit
            </v-icon>
          </v-btn>

          <v-btn
            @click="generarDocumentosInter(historialEnviosMostrador[0])"
            v-if="
              historialEnviosMostrador[0].ESTADO != 'Cancelado' &&
                historialEnviosMostrador[0].TIPO_SERVICIO == 'Paqueteria' &&
                (historialEnviosMostrador[0].DETALLE_ENVIO == 'Internacional Priority' ||
                  historialEnviosMostrador[0].DETALLE_ENVIO == 'Internacional Economy')
            "
            style="height:50px;font-size:20px;"
            dark
            class="mb-2"
            block
            color="purple"
          >
            IMPRIMIR DOCUMENTOS
            <v-icon small class="mr-2">
              mdi-receipt
            </v-icon>
          </v-btn>

          <v-btn
            v-if="historialEnviosMostrador[0].ESTADO != 'Cancelado' && logedInUserInfo.rol == '3'"
            block
            dark
            color="red"
            @click="eliminarEnvio(historialEnviosMostrador[0].REFERENCIA)"
            class="mb-2"
            style="height:50px;font-size:20px;"
          >
            CANCELAR ENVÍO
          </v-btn>
          <v-btn
            v-if="historialEnviosMostrador[0].ESTADO != 'Cancelado'"
            class="mb-2"
            @click="reimprimirTicket(historialEnviosMostrador[0])"
            block
            dark
            color="orange"
            style="height:50px;font-size:20px;"
          >
            REIMPRIMIR TICKET
            <v-icon small class="mr-2">
              mdi-receipt
            </v-icon>
          </v-btn>
          <v-btn
            style="height:50px;font-size:20px;"
            v-if="
              historialEnviosMostrador[0].ESTADO != 'Pagado' &&
                historialEnviosMostrador[0].ESTADO != 'Cancelado'
            "
            @click="
              realizarAbonoEnvio(
                historialEnviosMostrador[0].REFERENCIA,
                historialEnviosMostrador[0].ABONOS,
                historialEnviosMostrador[0].REMITENTE.nombre
              )
            "
            color="green"
            block
            dark
          >
            Abonar
            <v-icon small class="mr-2">
              mdi-cash-multiple
            </v-icon>
          </v-btn>
        </div>
        <div class="mt-3" style="display: flex; flex-wrap: wrap">
          <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">Cliente</v-card-title>
                <v-card-subtitle
                  v-text="historialEnviosMostrador[0].REMITENTE.nombre"
                ></v-card-subtitle>
              </div>
            </div>
          </v-card>
          <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">Destinatario</v-card-title>
                <v-card-subtitle
                  v-text="historialEnviosMostrador[0].DESTINATARIO.nombre"
                ></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="historialEnviosMostrador[0].DESTINATARIO.alias"
                ></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="historialEnviosMostrador[0].DESTINATARIO.telefono"
                ></v-card-subtitle>
              </div>
            </div>
          </v-card>
          <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
            <div class=" mt-3d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">Remitente</v-card-title>
                <v-card-subtitle
                  v-text="itemEnvioChido.TITULAR"
                  v-if="itemEnvioChido.TITULAR"
                ></v-card-subtitle>
                <v-card-subtitle v-text="itemEnvioChido.REMITENTE.nombre" v-else></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="itemEnvioChido.REMITENTE.alias"
                ></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="itemEnvioChido.REMITENTE.telefono"
                ></v-card-subtitle>
              </div>
            </div>
          </v-card>
          <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">Dirección de destino</v-card-title>
                <v-card-subtitle>{{
                  itemEnvioChido.DIRECCION[itemEnvioChido.DIRECCION.length - 1].direccion
                }}</v-card-subtitle>
                <v-card-subtitle style="margin-top:-35px;"
                  >{{ itemEnvioChido.DIRECCION[itemEnvioChido.DIRECCION.length - 1].colonia }} -
                  {{
                    itemEnvioChido.DIRECCION[itemEnvioChido.DIRECCION.length - 1].codigopostal
                  }}</v-card-subtitle
                >
                <v-card-subtitle style="margin-top:-35px;"
                  >{{ itemEnvioChido.DIRECCION[itemEnvioChido.DIRECCION.length - 1].municipio }} -
                  {{
                    itemEnvioChido.DIRECCION[itemEnvioChido.DIRECCION.length - 1].estado
                  }}</v-card-subtitle
                >
                <v-card-subtitle style="margin-top:-35px;">{{
                  itemEnvioChido.DIRECCION[itemEnvioChido.DIRECCION.length - 1].pais
                }}</v-card-subtitle>
              </div>
            </div>
          </v-card>
          <v-card
            v-if="itemEnvioChido.DIRECCION_REMITENTE"
            elevation="6"
            style="width:300px;"
            class="mr-2 mt-3"
            color="blue"
            dark
          >
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">Dirección de origen</v-card-title>
                <v-card-subtitle>{{
                  itemEnvioChido.DIRECCION_REMITENTE[itemEnvioChido.DIRECCION_REMITENTE.length - 1]
                    .direccion
                }}</v-card-subtitle>
                <v-card-subtitle style="margin-top:-35px;"
                  >{{
                    itemEnvioChido.DIRECCION_REMITENTE[
                      itemEnvioChido.DIRECCION_REMITENTE.length - 1
                    ].colonia
                  }}
                  -
                  {{
                    itemEnvioChido.DIRECCION_REMITENTE[
                      itemEnvioChido.DIRECCION_REMITENTE.length - 1
                    ].codigopostal
                  }}</v-card-subtitle
                >
                <v-card-subtitle style="margin-top:-35px;"
                  >{{
                    itemEnvioChido.DIRECCION_REMITENTE[
                      itemEnvioChido.DIRECCION_REMITENTE.length - 1
                    ].municipio
                  }}
                  -
                  {{
                    itemEnvioChido.DIRECCION_REMITENTE[
                      itemEnvioChido.DIRECCION_REMITENTE.length - 1
                    ].estado
                  }}</v-card-subtitle
                >
                <v-card-subtitle style="margin-top:-35px;">{{
                  itemEnvioChido.DIRECCION_REMITENTE[itemEnvioChido.DIRECCION_REMITENTE.length - 1]
                    .pais
                }}</v-card-subtitle>
                <v-card-subtitle style="margin-top:-35px;">México</v-card-subtitle>
              </div>
            </div>
          </v-card>
          <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">Datos envío</v-card-title>
                <v-card-subtitle
                  v-text="'Fecha: ' + historialEnviosMostrador[0].FECHA"
                ></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="'Tipo de Servicio: ' + historialEnviosMostrador[0].TIPO_SERVICIO"
                ></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="historialEnviosMostrador[0].DETALLE_ENVIO"
                ></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="'Estado: ' + historialEnviosMostrador[0].ESTADO"
                ></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="'Sucursal de envío ' + historialEnviosMostrador[0].SUCURSAL"
                ></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-text="'Cuenta envío: ' + historialEnviosMostrador[0].CUENTA"
                ></v-card-subtitle>
              </div>
            </div>
          </v-card>

          <v-card
            v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL"
            elevation="6"
            style="width:300px;"
            class="mr-2 mt-3"
            color="blue"
            dark
          >
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">Servicios adicionales</v-card-title>
                <v-card-subtitle></v-card-subtitle>
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL.correccion_direccion"
                  >Correción dirección:
                  {{
                    formateaMoneda(
                      reductorCorrecionDireccion(
                        historialEnviosMostrador[0].SERVICIO_ADICIONAL.correccion_direccion
                      )
                    )
                  }}</v-card-subtitle
                >
                <v-card-subtitle
                  style="margin-top:-35px;"
                  v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL.empaque"
                  >Empaque:
                  {{
                    formateaMoneda(historialEnviosMostrador[0].SERVICIO_ADICIONAL.empaque)
                  }}</v-card-subtitle
                >
                <v-card-subtitle
                  v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL.rempaque"
                  style="margin-top:-35px;"
                  >Reempaque:
                  {{
                    formateaMoneda(historialEnviosMostrador[0].SERVICIO_ADICIONAL.rempaque)
                  }}</v-card-subtitle
                >
                <v-card-subtitle
                  v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL.entrega_sabado"
                  style="margin-top:-35px;"
                  >Entrega en sábado:
                  {{
                    formateaMoneda(historialEnviosMostrador[0].SERVICIO_ADICIONAL.entrega_sabado)
                  }}</v-card-subtitle
                >
                <v-card-subtitle
                  v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL.recoleccion"
                  style="margin-top:-35px;"
                  >Recolección:
                  {{
                    formateaMoneda(historialEnviosMostrador[0].SERVICIO_ADICIONAL.recoleccion)
                  }}</v-card-subtitle
                >
                <v-card-subtitle
                  v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL.zona_expedida"
                  style="margin-top:-35px;"
                  >Zona extendida:
                  {{
                    formateaMoneda(historialEnviosMostrador[0].SERVICIO_ADICIONAL.zona_expedida)
                  }}</v-card-subtitle
                >
                <v-card-subtitle
                  v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL.servicio_guia"
                  style="margin-top:-35px;"
                  >Servicio guía:
                  {{
                    formateaMoneda(historialEnviosMostrador[0].SERVICIO_ADICIONAL.servicio_guia)
                  }}</v-card-subtitle
                >
                <v-card-subtitle
                  v-if="historialEnviosMostrador[0].SERVICIO_ADICIONAL.seguro"
                  style="margin-top:-35px;"
                  >Seguro:
                  {{ formateaMoneda(historialEnviosMostrador[0].SERVICIO_ADICIONAL.seguro) }} (Valor
                  declarado:
                  {{
                    formateaMoneda(historialEnviosMostrador[0].SERVICIO_ADICIONAL.valorcontenido)
                  }})</v-card-subtitle
                >
              </div>
            </div>
          </v-card>

          <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title class="headline">Sucursal</v-card-title>
                <v-card-subtitle>{{ historialEnviosMostrador[0].SUCURSAL }}</v-card-subtitle>
                <v-card-subtitle style="margin-top:-35px;">
                  Usuario: {{ historialEnviosMostrador[0].USUARIO }}</v-card-subtitle
                >
              </div>
            </div>
          </v-card>
          <div class="mt-3" style="display: flex; flex-wrap: wrap">
            <v-card
              v-for="(item4, index4) in historialEnviosMostrador[0].PAQUETES.InfoMensajeria"
              :key="index4"
              elevation="6"
              style="width:300px;"
              class="mr-2 mt-3"
              color="blue"
              dark
              ><div style="text-align:center;">
                <span style="font-size:30px;font-weight:bold;"> MENSAJERIA</span>
              </div>
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="headline">Mensaje #{{ index4 + 1 }}</v-card-title>
                  <v-card-subtitle>Peso kg: {{ item4.pesokg }}</v-card-subtitle>
                  <v-card-subtitle style="margin-top:-35px;"
                    >Guia: {{ formateaGuia(item4.guia) }}</v-card-subtitle
                  >
                </div>
              </div>
            </v-card>
          </div>
          <div class="mt-3" style="display: flex; flex-wrap: wrap">
            <v-card
              v-for="(item3, index3) in historialEnviosMostrador[0].PAQUETES.InfoPaquetes"
              :key="index3"
              elevation="6"
              style="width:300px;"
              class="mr-2 mt-3"
              color="blue"
              dark
              ><div style="text-align:center;">
                <span style="font-size:30px;font-weight:bold;"> PAQUETES</span>
              </div>
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="headline">Paquete # {{ index3 + 1 }}</v-card-title>
                  <v-card-subtitle>Alto: {{ item3.alto }}</v-card-subtitle>
                  <v-card-subtitle style="margin-top:-35px;"
                    >Largo: {{ item3.largo }} cm</v-card-subtitle
                  >
                  <v-card-subtitle style="margin-top:-35px;"
                    >Ancho: {{ item3.ancho }} cm</v-card-subtitle
                  >
                  <v-card-subtitle style="margin-top:-35px;"
                    >Peso kg: {{ item3.pesokg }} kg</v-card-subtitle
                  >
                  <v-card-subtitle style="margin-top:-35px;"
                    >Peso vol: {{ item3.pesovol }} kg</v-card-subtitle
                  >
                  <v-card-subtitle style="margin-top:-35px;"
                    >Guia FEDEX: {{ formateaGuia(item3.guia) }}</v-card-subtitle
                  >
                </div>
              </div>
            </v-card>
          </div>
          <div class="mb-3" style="display: flex; flex-wrap: wrap">
            <v-card elevation="6" style="width:300px;" class="mr-2 mt-3" color="blue" dark>
              <div style="text-align:center;">
                <span style="font-size:30px;font-weight:bold;"> ABONOS</span>
              </div>
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="headline">Total</v-card-title>
                  <v-card-subtitle
                    >Total envio:
                    {{ formateaMoneda(historialEnviosMostrador[0].ABONOS.total) }}</v-card-subtitle
                  >
                  <v-card-subtitle style="margin-top:-35px;">
                    Deuda actual:
                    {{
                      formateaMoneda(calculaDeudaActual(historialEnviosMostrador[0].ABONOS))
                    }}</v-card-subtitle
                  >
                </div>
              </div>
            </v-card>
            <v-card
              v-for="(item2, index2) in historialEnviosMostrador[0].ABONOS.Abonos"
              :key="index2"
              elevation="6"
              style="width:300px;"
              class="mr-2 mt-3"
              color="blue"
              dark
            >
              <div class="d-flex flex-no-wrap justify-space-between">
                <div>
                  <v-card-title class="headline">Abono #{{ index2 + 1 }}</v-card-title>
                  <v-card-subtitle> Fecha: {{ item2.fecha }}</v-card-subtitle>
                  <v-card-subtitle style="margin-top:-35px;"
                    >Cantidad abonada: {{ formateaMoneda(item2.cantidad) }}</v-card-subtitle
                  >
                  <v-card-subtitle style="margin-top:-35px;"
                    >Método de pago: {{ item2.tipo_pago }}</v-card-subtitle
                  >
                  <v-card-subtitle style="margin-top:-35px;"
                    >Usuario: {{ item2.usuario.nombre }}</v-card-subtitle
                  >
                </div>
              </div>
              <v-btn
                block
                class="p-3"
                @click="
                  reimprimirAbono(
                    {
                      IdEnvio: historialEnviosMostrador[0].REFERENCIA,
                      Fecha: item2.fecha,
                      ObjTotales: {
                        CostoEnvio: historialEnviosMostrador[0].ABONOS.total,
                        Abono: item2.cantidad,
                        SumAbonos:
                          historialEnviosMostrador[0].ABONOS.total -
                          calculaDeudaActual(historialEnviosMostrador[0].ABONOS),
                        DeudaEnvio: calculaDeudaActual(historialEnviosMostrador[0].ABONOS),
                        Cambio: '0'
                      }
                    },
                    itemEnvioChido.REMITENTE.nombre
                  )
                "
                ><v-icon small class="mr-2">
                  mdi-printer </v-icon
                >REIMPRIMIR ABONO</v-btn
              >
            </v-card>
          </div>
        </div>
      </v-col>
      <v-col cols="6" v-else style="text-align:center;">
        <span align="center" style="color:red;font-size:20px;font-weight:bold;">
          La busqueda realizada no obtuvo resultados
        </span>
      </v-col>
      <v-col cols="3"></v-col>
    </v-row>
    <AbonoEnvio
      @muestraMensaje="muestraAlertaEvento($event)"
      :idAbono="idAbonoModal"
      @cerrar-modal-abono-envio="modalAbonos = false"
      :mostrarAbonoEnvio="modalAbonos"
      :saldoEnvio="deudaUnSoloAbono"
      v-if="modalAbonos"
    />
    <ModalErrorEnAccion
      :mensajeError="mensajeErrorModalErrorEnAccion"
      :show="dialogErrorEnAccion"
      @cerrarModalEnAccion="dialogErrorEnAccion = false"
    />
    <ModalEdicionEnvios
      @mostrarMensajeError="
        asignaMensajeError($event);
        dialogErrorEnAccion = true;
      "
      @mostrar-mensaje-edicion-envios="
        snackbarHistorialEnvios = true;
        msgsnackbarHistorialEnvios = 'Envío editado con éxito';
        colorSnackbar = 'blue';
        obtenerEnviosMostrador();
      "
      @cerrar-modal-edicion-envios="mostrarModalEdicionEnvios = false"
      v-if="mostrarModalEdicionEnvios"
      :idEnvioEditar="idEnviadaEnvioEditar"
      :show="mostrarModalEdicionEnvios"
    />
    <ModalCambioDireccion
      v-if="mostrarModalCambioDireccion"
      @cerrar-modal-cdir="seHizoCambioDireccion($event)"
      @recargaPagina="obtenerEnviosMostrador()"
      :show="mostrarModalCambioDireccion"
      :idEnvio="idEnvioObtenida"
      :direccionPasada="direccionObtenida"
    />
    <ModalPrevioGenerarDocumentos
      @aceptarModalDocumentacion="modalDocumentacionAceptar()"
      @cerrarModalDocumentacion="mostrarModalGeneracionDocumentos = false"
      v-if="mostrarModalGeneracionDocumentos"
      :show="mostrarModalGeneracionDocumentos"
    />
    <v-snackbar
      v-model="snackbarHistorialEnvios"
      timeout="2000"
      rounded="pill"
      centered
      elevation="8"
      :color="colorSnackbar"
      ><span style="font-size:20px;">
        <v-icon medium> mdi-alert-circle </v-icon>
        {{ msgsnackbarHistorialEnvios }} <v-icon medium> mdi-alert-circle </v-icon>
      </span></v-snackbar
    >
    <v-overlay :value="loaderEnviosMostrador">
      <v-progress-circular indeterminate size="100"></v-progress-circular>
    </v-overlay>
    <v-row class="imprimir">
      <TicketDeCompra v-if="documentoAGenerar == 1" />
      <CommercialInvoice v-if="documentoAGenerar == 2" />
      <div style="height:10px"></div>
      <TMEC v-if="documentoAGenerar == 2 && hayTMEC" />
    </v-row>
    <v-dialog
      v-model="dialogConfirmarEliminacion"
      persistent
      max-width="760"
      v-if="dialogConfirmarEliminacion"
    >
      <v-card>
        <v-card-title class="headline">Confirmar cancelación</v-card-title>
        <v-card-text>
          <span style="font-size:25px;">
            ¿Está seguro que desea cancelar este envío? <br />
            Esta opción no se puede deshacer.</span
          >
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" @click="dialogConfirmarEliminacion = false" text
            >Cancelar</v-btn
          >
          <v-btn color="red darken-1" @click="confirmarEliminacionEnvios()" text>Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <img
      class="noimprimir"
      src="../assets/qr_code.png"
      style="height:1px;width:1px;"
      alt="contrato de privacidad"
    />
  </v-container>
</template>
<script>
import { FormatoMoneda, FormatoGuia } from "@/Utils/Utils";
import TicketDeCompra from "@/components/TicketDeCompra.vue";
import CommercialInvoice from "@/components/documentos-generados/CommercialInvoice.vue";
import TMEC from "@/components/documentos-generados/TMEC.vue";
import ModalPrevioGenerarDocumentos from "@/components/modales/ModalPrevioGenerarDocumentos.vue";
import _ from "lodash";
import ModalCambioDireccion from "@/components/modales/ModalCambioDireccionSA.vue";
import ModalEdicionEnvios from "@/components/modales/ModalEdicionEnvios.vue";
import ModalErrorEnAccion from "@/components/modales/ModalErrorEnAccion.vue";
import AbonoEnvio from "@/components/AbonoEnvio.vue";
import { mapState, mapActions } from "vuex";
export default {
  components: {
    AbonoEnvio,
    ModalCambioDireccion,
    TicketDeCompra,
    ModalEdicionEnvios,
    ModalErrorEnAccion,
    CommercialInvoice,
    TMEC,
    ModalPrevioGenerarDocumentos
  },
  data: () => ({
    hayTMEC: false,
    mostrarModalGeneracionDocumentos: false,
    documentoAGenerar: 1,
    dialogConfirmarEliminacion: false,
    idItemAborrar: 0,
    dialogErrorEnAccion: false,
    mensajeErrorModalErrorEnAccion: "",
    mostrarModalEdicionEnvios: false,
    idEnviadaEnvioEditar: "",
    nombreDeAbonadorx: "nulo",
    imprimirTicket: true,
    mostrarModalCambioDireccion: false,
    idEnvioObtenida: "",
    direccionObtenida: "",
    loaderEnviosMostrador: false,
    snackbarHistorialEnvios: false,
    msgsnackbarHistorialEnvios: "",
    colorSnackbar: "",
    referenciaEnvio: "",
    modalAbonos: false,
    idAbonoModal: "",
    deudaUnSoloAbono: 0
  }),
  computed: {
    ...mapState("enviosConsultaMostrador", {
      historialEnviosMostrador: state => state.historialEnviosMostrador
    }),
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData,
      logedInUserInfo: state => state.logedInUserInfo
    }),
    itemEnvioChido() {
      return this.historialEnviosMostrador[0];
    }
  },
  beforeDestroy() {
    this.destroyEnviosMostrador();
  },
  methods: {
    ...mapActions("enviosInsercion", ["deleteEnvios"]),
    ...mapActions("enviosConsultaMostrador", ["getEnviosMostrador", "destroyEnviosMostrador"]),
    ...mapActions("abonosEnvios", [
      "registraNombreAbonante",
      "destroyStoreAbonosEnvios",
      "reimprimirTicketAbono"
    ]),
    ...mapActions("documentosInternacional", ["chargeInfoDocumento", "destroyInfoDocumentos"]),
    ...mapActions("ofuscadorFirma", ["convertirVariableTrue", "convertirVariableFalse"]),
    ...mapActions("enviosInfoEnvio", [
      "chargeinfoEnvio",
      "chargeInfoEnvioGeneradaDespues",
      "destroyStoreInfoEnvio",
      "chargeGuiasAgregadasDespues"
    ]),
    async reimprimirAbono(infoAbonoReimprimir, abonanteNombre) {
      this.documentoAGenerar = 1;
      await this.destroyInfoDocumentos();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();

      await this.registraNombreAbonante(abonanteNombre);
      await this.reimprimirTicketAbono(infoAbonoReimprimir);
      window.print();

      console.log(infoAbonoReimprimir);
    },
    mostrarBotonEditarGuias(item) {
      let Fecha = new Date();
      let DiaMes = Fecha.getDate() < 10 ? `0${Fecha.getDate()}` : Fecha.getDate();
      let Mes = Fecha.getMonth() + 1;
      let MesA = parseInt(Mes) < 10 ? `0${Mes}` : Mes;
      let Anio = Fecha.getFullYear();

      let FechaSistema = `${DiaMes}/${MesA}/${Anio}`;

      if (FechaSistema == item.FECHA.substring(0, 10)) {
        return true;
      } else {
        return false;
      }
    },
    async modalDocumentacionAceptar() {
      this.mostrarModalGeneracionDocumentos = false;
      await this.imprimirXD();
    },
    imprimirXD: _.debounce(async function() {
      window.print();
    }, 400),

    async generarDocumentosInter(dataEnviada) {
      await this.destroyInfoDocumentos();
      await this.destroyInfoDocumentos();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();

      //todo este bloque de codigo, es para:
      // 1 agrupar todas las fracciones en un unico arreglo
      // 2 agrupar fracciones sin sinRepetir
      // 3 sacar costo total del envio multiplicando cada fraccion por su valor unitario y sumando
      let todasFracciones = [];
      for (let i = 0; i < dataEnviada.PAQUETES.InfoPaquetes.length; i++) {
        for (let j = 0; j < dataEnviada.PAQUETES.InfoPaquetes[i].fa.length; j++) {
          todasFracciones.push(dataEnviada.PAQUETES.InfoPaquetes[i].fa[j]);
        }
      }
      const sinRepetir = JSON.parse(JSON.stringify(todasFracciones)).reduce((a, b) => {
        if (a[b.id]) {
          a[b.id].cantidad = parseFloat(a[b.id].cantidad) + parseFloat(b.cantidad);
        } else a[b.id] = b;
        return a;
      }, {});
      const todasFraccionesSinRepetir = Object.values(sinRepetir);
      let costoTotal = todasFraccionesSinRepetir.reduce(
        (a, b) => a + b.cantidad * b.valor_unitario,
        0
      );
      //termina bloque de codigo de calculo de total
      this.mostrarModalGeneracionDocumentos = true;
      // el tmec solo se usa para envios mayores a 115 dolares
      if (
        ["México", "Estados Unidos", "Canadá"].includes(dataEnviada.DIRECCION[0].pais) &&
        costoTotal > 115
      ) {
        this.hayTMEC = true;
      } else {
        this.hayTMEC = false;
      }
      this.documentoAGenerar = 2;

      await this.chargeInfoDocumento({
        tipoDocumento: "CommercialInvoice",
        informacion: dataEnviada
      });
      // window.print();
    },

    async confirmarEliminacionEnvios() {
      const res = await this.deleteEnvios(this.idItemAborrar);
      this.dialogConfirmarEliminacion = false;
      if (res[0]) {
        this.snackbarHistorialEnvios = true;
        this.msgsnackbarHistorialEnvios = "Envío cancelado con éxito";
        this.colorSnackbar = "blue";
        await this.obtenerEnviosMostrador();
      }
    },

    eliminarEnvio(reff) {
      this.idItemAborrar = reff;
      this.dialogConfirmarEliminacion = true;
    },
    asignaMensajeError(res) {
      this.mensajeErrorModalErrorEnAccion = JSON.stringify(res);
    },

    async editarEnvio(item) {
      this.idEnviadaEnvioEditar = item;
      this.mostrarModalEdicionEnvios = true;
    },
    // async generarDocumentosInter(dataEnviada) {
    //   this.documentoAGenerar = 2;
    //   await this.destroyInfoDocumentos();
    //   await this.destroyStoreInfoEnvio();
    //   await this.destroyStoreAbonosEnvios();
    //   await this.destroyStoreInfoEnvio();
    //   await this.destroyStoreAbonosEnvios();
    //   await this.chargeInfoDocumento({
    //     tipoDocumento: "CommercialInvoice",
    //     informacion: dataEnviada
    //   });
    //   window.print();
    // },
    async reimprimirTicket(datosEnvioElegido) {
      this.documentoAGenerar = 1;
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();
      await this.destroyStoreInfoEnvio();
      await this.destroyStoreAbonosEnvios();
      console.warn("datos envios para reimprimir ticket", datosEnvioElegido);
      if (
        datosEnvioElegido.DETALLE_ENVIO == "Nacional Dia siguiente" ||
        datosEnvioElegido.DETALLE_ENVIO == "Nacional Terrestre"
      ) {
        var datosEnvio = new Object();
        if (
          datosEnvioElegido.DETALLE_ENVIO == "Nacional Dia siguiente" &&
          datosEnvioElegido.TIPO_SERVICIO == "Paqueteria"
        ) {
          datosEnvio.tipoEnvio = "Paqueteria nacional día siguiente";
        } else if (
          datosEnvioElegido.DETALLE_ENVIO == "Nacional Terrestre" &&
          datosEnvioElegido.TIPO_SERVICIO == "Paqueteria"
        ) {
          datosEnvio.tipoEnvio = "Paqueteria nacional terrestre";
        } else if (
          datosEnvioElegido.DETALLE_ENVIO == "Nacional Terrestre" &&
          datosEnvioElegido.TIPO_SERVICIO == "Mensajeria"
        ) {
          datosEnvio.tipoEnvio = "Mensajeria nacional terrestre";
        } else {
          datosEnvio.tipoEnvio = "Mensajeria nacional día siguiente";
        }

        datosEnvio.DescripcionEnvioNacional = datosEnvioElegido.PAQUETES.Descripcion;

        //esta excepcion es para los envios internacionales, generamos el objeto para ese caso
      } else if (
        datosEnvioElegido.DETALLE_ENVIO == "Internacional Priority" ||
        datosEnvioElegido.DETALLE_ENVIO == "Internacional Economy"
      ) {
        var datosEnvio = new Object();
        //primero cargamos la informacion del tipo de envio que se hará
        if (
          datosEnvioElegido.DETALLE_ENVIO == "Internacional Priority" &&
          datosEnvioElegido.TIPO_SERVICIO == "Paqueteria"
        ) {
          datosEnvio.tipoEnvio = "Paqueteria internacional priority";
        } else if (
          datosEnvioElegido.DETALLE_ENVIO == "Internacional Economy" &&
          datosEnvioElegido.TIPO_SERVICIO == "Paqueteria"
        ) {
          datosEnvio.tipoEnvio = "Paqueteria Internacional economy";
        } else if (
          datosEnvioElegido.DETALLE_ENVIO == "Internacional Priority" &&
          datosEnvioElegido.TIPO_SERVICIO == "Mensajeria"
        ) {
          datosEnvio.tipoEnvio = "Mensajeria internacional priority";
        } else {
          datosEnvio.tipoEnvio = "Mensajeria internacional economy";
        }

        //cargamos la informacion de descripcion de inter y de destinatario
        datosEnvio.DescripcionEnvioInter = datosEnvioElegido.PAQUETES.Descripcion;

        // TODO lo de abajo aplica para ambos tipos de envio, lo de arriba no
      }

      datosEnvio.InfoDestinatario = new Object();
      datosEnvio.InfoDestinatario.alias = datosEnvioElegido.DESTINATARIO.alias;
      datosEnvio.InfoDestinatario.nombre = datosEnvioElegido.DESTINATARIO.nombre;
      datosEnvio.InfoDestinatario.telefono = datosEnvioElegido.DESTINATARIO.telefono;

      datosEnvio.InfoDestinatario.ciudad = datosEnvioElegido.DIRECCION[0].municipio;
      datosEnvio.InfoDestinatario.colonia = datosEnvioElegido.DIRECCION[0].colonia;
      datosEnvio.InfoDestinatario.cp = datosEnvioElegido.DIRECCION[0].codigopostal;
      datosEnvio.InfoDestinatario.direccion = datosEnvioElegido.DIRECCION[0].direccion;
      datosEnvio.InfoDestinatario.estado = datosEnvioElegido.DIRECCION[0].estado;
      datosEnvio.InfoDestinatario.pais = datosEnvioElegido.DIRECCION[0].pais;
      datosEnvio.InfoDestinatario.email = "";
      // remitente
      datosEnvio.InfoRemitente = new Object();
      datosEnvio.InfoRemitente.nombre = datosEnvioElegido.REMITENTE.nombre;

      datosEnvio.InfoRemitente.ciudad = datosEnvioElegido.DIRECCION_REMITENTE[0].municipio;
      datosEnvio.InfoRemitente.colonia = datosEnvioElegido.DIRECCION_REMITENTE[0].colonia;
      datosEnvio.InfoRemitente.cp = datosEnvioElegido.DIRECCION_REMITENTE[0].codigopostal;
      datosEnvio.InfoRemitente.direccion = datosEnvioElegido.DIRECCION_REMITENTE[0].direccion;
      datosEnvio.InfoRemitente.estado = datosEnvioElegido.DIRECCION_REMITENTE[0].estado;
      datosEnvio.InfoRemitente.pais = datosEnvioElegido.DIRECCION_REMITENTE[0].pais;

      datosEnvio.Titular = datosEnvioElegido.TITULAR + "";

      //total
      datosEnvio.InfoPagos = new Object();
      datosEnvio.InfoPagos.Total = datosEnvioElegido.ABONOS.total;
      //pagado
      datosEnvio.InfoPagos.cantidad =
        datosEnvioElegido.ABONOS.total - (await this.calculaDeudaActual(datosEnvioElegido.ABONOS));

      //usuario del envio
      datosEnvio.InfoUsuario = new Object();
      datosEnvio.InfoUsuario.nombre = this.logedInUserInfo.nombre;

      if (datosEnvioElegido.TIPO_SERVICIO == "Mensajeria") {
        datosEnvio.InfoMensajeria = new Object();
        //arreglar aqui
        datosEnvio.DescripcionMensajeriaFinal = datosEnvioElegido.PAQUETES.Descripcion;
        datosEnvio.InfoMensajeria = datosEnvioElegido.PAQUETES.InfoMensajeria[0];
        datosEnvio.InfoMensajeria.guiaRastreo = datosEnvioElegido.PAQUETES.InfoMensajeria[0].guia;
      } else {
        datosEnvio.InfoPaqueteriaN = new Object();
        datosEnvio.InfoPaqueteriaN = datosEnvioElegido.PAQUETES.InfoPaquetes;
      }
      //servicios adicionales

      if (datosEnvioElegido.SERVICIO_ADICIONAL != null) {
        datosEnvio.ServiciosAdicionales = new Object();
        if (datosEnvioElegido.SERVICIO_ADICIONAL.empaque) {
          datosEnvio.ServiciosAdicionales.empaque = datosEnvioElegido.SERVICIO_ADICIONAL.empaque;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.rempaque) {
          datosEnvio.ServiciosAdicionales.rempaque = datosEnvioElegido.SERVICIO_ADICIONAL.rempaque;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.entrega_sabado) {
          datosEnvio.ServiciosAdicionales.entrega_sabado =
            datosEnvioElegido.SERVICIO_ADICIONAL.entrega_sabado;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.recoleccion) {
          datosEnvio.ServiciosAdicionales.recoleccion =
            datosEnvioElegido.SERVICIO_ADICIONAL.recoleccion;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.seguro) {
          datosEnvio.ServiciosAdicionales.seguro = datosEnvioElegido.SERVICIO_ADICIONAL.seguro;
          datosEnvio.ServiciosAdicionales.valorcontenido =
            datosEnvioElegido.SERVICIO_ADICIONAL.valorcontenido;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.servicio_guia) {
          datosEnvio.ServiciosAdicionales.servicio_guia =
            datosEnvioElegido.SERVICIO_ADICIONAL.servicio_guia;
        }
        if (datosEnvioElegido.SERVICIO_ADICIONAL.zona_expedida) {
          datosEnvio.ServiciosAdicionales.zona_expedida =
            datosEnvioElegido.SERVICIO_ADICIONAL.zona_expedida;
        }
      }

      //aqui mandamos los datos que se envian despues para el ticket y
      //cargamos los datos del objeto de envio que acabamos de crear
      var datosEnvioDespues = new Object();
      datosEnvioDespues.envio = {
        Fecha: datosEnvioElegido.FECHA,
        ID: datosEnvioElegido.REFERENCIA
      };

      await this.chargeinfoEnvio(datosEnvio);
      await this.chargeInfoEnvioGeneradaDespues(datosEnvioDespues);
      let arrayGuias = [];
      if (datosEnvioElegido.TIPO_SERVICIO == "Paqueteria") {
        for (let i = 0; i < datosEnvioElegido.PAQUETES.InfoPaquetes.length; i++) {
          arrayGuias.push(datosEnvioElegido.PAQUETES.InfoPaquetes[i].guia);
        }
      }
      await this.chargeGuiasAgregadasDespues(arrayGuias);

      //esto de abajo se hace para ambos no importa si son inter o nacionales

      await this.convertirVariableTrue();
      window.print();
      await this.convertirVariableFalse();
      window.print();
    },
    formateaGuia(guia) {
      return FormatoGuia(guia);
    },
    formateaMoneda(moneda) {
      return FormatoMoneda.format(moneda);
    },
    async delaySeHizoCambioDireccion() {
      this.mostrarModalCambioDireccion = false;
      await this.obtenerEnviosMostrador();
    },
    async seHizoCambioDireccion(estado) {
      await this.delaySeHizoCambioDireccion();
      if (estado == "cambiodireccioncorrecto") {
        window.print();
        window.print();
      }
    },
    obtenerEnviosMostrador: _.debounce(async function() {
      this.loaderEnviosMostrador = true;
      await this.getEnviosMostrador(this.referenciaEnvio);
      this.loaderEnviosMostrador = false;
    }, 400),
    reductorCorrecionDireccion(arrCostoDirecciones) {
      let total = 0;
      for (let index = 0; index < arrCostoDirecciones.length; index++) {
        total += parseFloat(arrCostoDirecciones[index]);
      }
      return total;
    },
    delayedAbonosOcultarModal() {
      this.modalAbonos = false;
      this.snackbarHistorialEnvios = true;
      this.msgsnackbarHistorialEnvios = "Abono correctamente realizado";

      this.colorSnackbar = "blue darken-1";
    },
    async muestraAlertaEvento(evento) {
      if (evento == "abonoCorrecto") {
        await this.delayedAbonosOcultarModal();
        window.print();
        window.print();
      } else if (evento == "envioprevpagado") {
        this.modalAbonos = false;
        this.snackbarHistorialEnvios = true;
        this.msgsnackbarHistorialEnvios =
          "El envio ya está completamente pagado, no es posible realizar otro abono.";
        this.colorSnackbar = "red darken-1";
      }
      this.obtenerEnviosMostrador();
    },
    async realizarAbonoEnvio(referencia, abonos, nombreCliente) {
      //this.nombreDeAbonadorx = this.historialEnviosMostrador[0].REMITENTE.nombre;
      await this.registraNombreAbonante(nombreCliente);
      const deudaEnvioEspecifico = await this.calculaDeudaActual(abonos);
      this.deudaUnSoloAbono = deudaEnvioEspecifico;
      this.idAbonoModal = referencia;
      this.modalAbonos = true;
    },
    calculaDeudaActual(abonos) {
      let pagosHechos = 0;
      for (var i = 0; i < abonos.Abonos.length; i++) {
        pagosHechos += parseFloat(abonos.Abonos[i].cantidad);
      }
      const deudaActual = parseFloat(abonos.total) - parseFloat(pagosHechos);
      return deudaActual;
    }
  }
};
</script>
<style lang="css" scoped>
.imprimir {
  display: none;
}
@media print {
  .noimprimir {
    display: none;
  }
  .imprimir {
    display: block;
  }
}
</style>
